import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { arrayOf, func, shape } from 'prop-types';
import {
  AUIFilterBar,
  AUIClearFilter,
  AUISearchFilter,
  AUIWrapperFilter,
  AUISelectFilter,
  AUICalendarFilter,
  AUISwitchFilter,
} from '@ancert/aui-filter-bar';
import { AUITable } from '@ancert/aui-table';
import { useSession } from '../../../context/session.context';
import getColumns from './columns';
import { SEARCH_OPTIONS, SELECT_OPTIONS, generateFilter, localFilterData } from './filter';
import { ROUTES } from '../../../constants';
import ModalAsignarDenuncia from '../../../components/ModalAsignarDenuncia';
import ModalReestablecerContrasena from '../../../components/ModalReestablecerContrasena';
import { ROL } from '../../../lib/role.enum';
import { PAGE_SIZE } from '../../../config';

const ListadoAdmin = ({ data, reload }) => {
  const tableRef = useRef(null);
  const history = useHistory();
  const { getRenewPassword, getUser } = useSession();
  const { role } = getUser();
  const [show, setShow] = useState(false);
  const [complaintId, setComplaintId] = useState(null);
  const [dataFilter, setDataFilter] = useState(null);
  const [isShowRenewPass, setShowRenewPass] = useState(false);
  const dataFiltered = localFilterData({
    data,
    filter: dataFilter,
    idPermission: [ROL.ADMINISTRADOR, ROL.RESPONSABLE].includes(role),
  });

  useEffect(() => {
    setShowRenewPass(getRenewPassword());
  }, []);

  const onApplyFilter = (filter) => {
    const applyFilter = generateFilter(filter);
    setDataFilter(applyFilter);
    tableRef.current.resetPagination();
  };

  const onRowVer = (id) => {
    history.push(`${ROUTES.CONSULTAR_DENUNCIA}/${id}`);
  };

  const onRowAsignar = (id) => {
    setComplaintId(id);
    setShow(true);
  };

  return (
    <div>
      <h1>Listado de denuncias</h1>
      <AUIFilterBar
        tagBar
        onSubmit={onApplyFilter}
        onReset={() => {
          setDataFilter(null);
        }}
      >
        <AUIWrapperFilter position="left">
          <AUISearchFilter name="filter" options={SEARCH_OPTIONS} />
        </AUIWrapperFilter>
        <AUIWrapperFilter position="center">
          <AUICalendarFilter name="date" label="Fecha denuncia" selectionMode="range" />
          <AUISelectFilter label="Estado" name="status" options={SELECT_OPTIONS} />
        </AUIWrapperFilter>
        <AUIWrapperFilter position="right">
          <AUISwitchFilter description="Ver solo pendientes" name="isPendiente" />
          <AUIClearFilter label="Reiniciar filtros" />
        </AUIWrapperFilter>
      </AUIFilterBar>
      <AUITable
        ref={tableRef}
        dataId="id"
        className="u-mt-16"
        columns={getColumns(
          { onRowVer, onRowAsignar },
          role === ROL.ADMINISTRADOR,
          [ROL.ADMINISTRADOR, ROL.RESPONSABLE].includes(role)
        )}
        data={dataFiltered}
        forcePagination
        pageSize={PAGE_SIZE.LISTADO_DENUNCIAS}
        totalData={dataFiltered?.length}
      />
      {[ROL.ADMINISTRADOR, ROL.RESPONSABLE].includes(role) && (
        <ModalAsignarDenuncia show={show} setShow={() => setShow(false)} id={complaintId} reload={reload} />
      )}
      <ModalReestablecerContrasena show={isShowRenewPass} onClose={() => setShowRenewPass(false)} />
    </div>
  );
};

ListadoAdmin.propTypes = {
  data: arrayOf(shape({})),
  reload: func.isRequired,
};

ListadoAdmin.defaultProps = {
  data: [],
};

export default ListadoAdmin;
